export const imagesXS = {
  "left": [
    {
      "orig": "Dinge41",
      "url": "http://noravest.ch/img/Dinge41.jpg",
      "tn": "http://noravest.ch/img/Dinge41_xstn.jpg",
      "width": "386",
      "height": "580",
    },
    {
      "orig": "Dinge42",
      "url": "http://noravest.ch/img/Dinge42.jpg",
      "tn": "http://noravest.ch/img/Dinge42_xstn.jpg",
      "width": "386",
      "height": "580",
    },
    {
      "orig": "Dinge43",
      "url": "http://noravest.ch/img/Dinge43.jpg",
      "tn": "http://noravest.ch/img/Dinge43_xstn.jpg",
      "width": "386",
      "height": "580",
    },
    {
      "orig": "Dinge44",
      "url": "http://noravest.ch/img/Dinge44.jpg",
      "tn": "http://noravest.ch/img/Dinge44_xstn.jpg",
      "width": "386",
      "height": "580",
    },
    {
      "orig": "Dinge45",
      "url": "http://noravest.ch/img/Dinge45.jpg",
      "tn": "http://noravest.ch/img/Dinge45_xstn.jpg",
      "width": "386",
      "height": "580",
    }
  ],
  "centerleft": [
    {
      "orig": "Liegen-ge-Bliebenes2",
      "url": "http://noravest.ch/img/Liegen-ge-Bliebenes2.jpg",
      "tn": "http://noravest.ch/img/Liegen-ge-Bliebenes2_xstn.jpg",
      "width": "700",
      "height": "525",
    },
    {
      "orig": "Liegen-ge-Bliebenes25",
      "url": "http://noravest.ch/img/Liegen-ge-Bliebenes25.jpg",
      "tn": "http://noravest.ch/img/Liegen-ge-Bliebenes25_xstn.jpg",
      "width": "700",
      "height": "525",
    }],
  "centercenter":[
    {
      "orig": "Liegen-ge-Bliebenes23",
      "url": "http://noravest.ch/img/Liegen-ge-Bliebenes23.jpg",
      "tn": "http://noravest.ch/img/Liegen-ge-Bliebenes23_xstn.jpg",
      "width": "700",
      "height": "525",
    },
    {
      "orig": "Liegen-ge-Bliebenes33",
      "url": "http://noravest.ch/img/Liegen-ge-Bliebenes33.jpg",
      "tn": "http://noravest.ch/img/Liegen-ge-Bliebenes33_xstn.jpg",
      "width": "700",
      "height": "525",
    }],
    "centerright":[
    {
      "orig": "Liegen-ge-Bliebenes26",
      "url": "http://noravest.ch/img/Liegen-ge-Bliebenes26.jpg",
      "tn": "http://noravest.ch/img/Liegen-ge-Bliebenes26_xstn.jpg",
      "width": "700",
      "height": "525",
    },
    {
      "orig": "Liegen-ge-Bliebenes24",
      "url": "http://noravest.ch/img/Liegen-ge-Bliebenes24.jpg",
      "tn": "http://noravest.ch/img/Liegen-ge-Bliebenes24_xstn.jpg",
      "width": "700",
      "height": "525",
    }
  ],
  "right": [
    {
      "orig": "Dinge51",
      "url": "http://noravest.ch/img/Dinge51.jpg",
      "tn": "http://noravest.ch/img/Dinge51_xstn.jpg",
      "width": "386",
      "height": "580",
    },
    {
      "orig": "Dinge52",
      "url": "http://noravest.ch/img/Dinge52.jpg",
      "tn": "http://noravest.ch/img/Dinge52_xstn.jpg",
      "width": "386",
      "height": "580",
    },
    {
      "orig": "Dinge53",
      "url": "http://noravest.ch/img/Dinge53.jpg",
      "tn": "http://noravest.ch/img/Dinge53_xstn.jpg",
      "width": "386",
      "height": "580",
    },
    {
      "orig": "Dinge54",
      "url": "http://noravest.ch/img/Dinge54.jpg",
      "tn": "http://noravest.ch/img/Dinge54_xstn.jpg",
      "width": "386",
      "height": "580",
    },
    {
      "orig": "Dinge55",
      "url": "http://noravest.ch/img/Dinge55.jpg",
      "tn": "http://noravest.ch/img/Dinge55_xstn.jpg",
      "width": "386",
      "height": "580",
    }
  ]
};

export const imagesSM = {
  "left": [
    {
      "orig": "Dinge41",
      "url": "http://noravest.ch/img/Dinge41.jpg",
      "tn": "http://noravest.ch/img/Dinge41_smtn.jpg",
      "width": "386",
      "height": "580",
    },
    {
      "orig": "Dinge42",
      "url": "http://noravest.ch/img/Dinge42.jpg",
      "tn": "http://noravest.ch/img/Dinge42_smtn.jpg",
      "width": "386",
      "height": "580",
    },
    {
      "orig": "Dinge43",
      "url": "http://noravest.ch/img/Dinge43.jpg",
      "tn": "http://noravest.ch/img/Dinge43_smtn.jpg",
      "width": "386",
      "height": "580",
    },
    {
      "orig": "Dinge44",
      "url": "http://noravest.ch/img/Dinge44.jpg",
      "tn": "http://noravest.ch/img/Dinge44_smtn.jpg",
      "width": "386",
      "height": "580",
    },
    {
      "orig": "Dinge45",
      "url": "http://noravest.ch/img/Dinge45.jpg",
      "tn": "http://noravest.ch/img/Dinge45_smtn.jpg",
      "width": "386",
      "height": "580",
    }
  ],
  "centerleft": [
    {
      "orig": "Liegen-ge-Bliebenes2",
      "url": "http://noravest.ch/img/Liegen-ge-Bliebenes2.jpg",
      "tn": "http://noravest.ch/img/Liegen-ge-Bliebenes2_smtn.jpg",
      "width": "700",
      "height": "525",
    },
    {
      "orig": "Liegen-ge-Bliebenes25",
      "url": "http://noravest.ch/img/Liegen-ge-Bliebenes25.jpg",
      "tn": "http://noravest.ch/img/Liegen-ge-Bliebenes25_smtn.jpg",
      "width": "700",
      "height": "525",
    }],
    "centercenter":[
    {
      "orig": "Liegen-ge-Bliebenes23",
      "url": "http://noravest.ch/img/Liegen-ge-Bliebenes23.jpg",
      "tn": "http://noravest.ch/img/Liegen-ge-Bliebenes23_smtn.jpg",
      "width": "700",
      "height": "525",
    },
    {
      "orig": "Liegen-ge-Bliebenes33",
      "url": "http://noravest.ch/img/Liegen-ge-Bliebenes33.jpg",
      "tn": "http://noravest.ch/img/Liegen-ge-Bliebenes33_smtn.jpg",
      "width": "700",
      "height": "525",
    }],
    "centerright":[
    {
      "orig": "Liegen-ge-Bliebenes26",
      "url": "http://noravest.ch/img/Liegen-ge-Bliebenes26.jpg",
      "tn": "http://noravest.ch/img/Liegen-ge-Bliebenes26_smtn.jpg",
      "width": "700",
      "height": "525",
    },
    {
      "orig": "Liegen-ge-Bliebenes24",
      "url": "http://noravest.ch/img/Liegen-ge-Bliebenes24.jpg",
      "tn": "http://noravest.ch/img/Liegen-ge-Bliebenes24_smtn.jpg",
      "width": "700",
      "height": "525",
    }
  ],
  "right": [
    {
      "orig": "Dinge51",
      "url": "http://noravest.ch/img/Dinge51.jpg",
      "tn": "http://noravest.ch/img/Dinge51_smtn.jpg",
      "width": "386",
      "height": "580",
    },
    {
      "orig": "Dinge52",
      "url": "http://noravest.ch/img/Dinge52.jpg",
      "tn": "http://noravest.ch/img/Dinge52_smtn.jpg",
      "width": "386",
      "height": "580",
    },
    {
      "orig": "Dinge53",
      "url": "http://noravest.ch/img/Dinge53.jpg",
      "tn": "http://noravest.ch/img/Dinge53_smtn.jpg",
      "width": "386",
      "height": "580",
    },
    {
      "orig": "Dinge54",
      "url": "http://noravest.ch/img/Dinge54.jpg",
      "tn": "http://noravest.ch/img/Dinge54_smtn.jpg",
      "width": "386",
      "height": "580",
    },
    {
      "orig": "Dinge55",
      "url": "http://noravest.ch/img/Dinge55.jpg",
      "tn": "http://noravest.ch/img/Dinge55_smtn.jpg",
      "width": "386",
      "height": "580",
    }
  ]
};

export const imagesMD = {
  "left": [
    {
      "orig": "Dinge41",
      "url": "http://noravest.ch/img/Dinge41.jpg",
      "tn": "http://noravest.ch/img/Dinge41tn.jpg",
      "width": "386",
      "height": "580",
    },
    {
      "orig": "Dinge42",
      "url": "http://noravest.ch/img/Dinge42.jpg",
      "tn": "http://noravest.ch/img/Dinge42tn.jpg",
      "width": "386",
      "height": "580",
    },
    {
      "orig": "Dinge43",
      "url": "http://noravest.ch/img/Dinge43.jpg",
      "tn": "http://noravest.ch/img/Dinge43tn.jpg",
      "width": "386",
      "height": "580",
    },
    {
      "orig": "Dinge44",
      "url": "http://noravest.ch/img/Dinge44.jpg",
      "tn": "http://noravest.ch/img/Dinge44tn.jpg",
      "width": "386",
      "height": "580",
    },
    {
      "orig": "Dinge45",
      "url": "http://noravest.ch/img/Dinge45.jpg",
      "tn": "http://noravest.ch/img/Dinge45tn.jpg",
      "width": "386",
      "height": "580",
    }
  ],
  "centerleft": [
    {
      "orig": "Liegen-ge-Bliebenes2",
      "url": "http://noravest.ch/img/Liegen-ge-Bliebenes2.jpg",
      "tn": "http://noravest.ch/img/Liegen-ge-Bliebenes2tn.jpg",
      "width": "700",
      "height": "525",
    },
    {
      "orig": "Liegen-ge-Bliebenes25",
      "url": "http://noravest.ch/img/Liegen-ge-Bliebenes25.jpg",
      "tn": "http://noravest.ch/img/Liegen-ge-Bliebenes25tn.jpg",
      "width": "700",
      "height": "525",
    }],
    "centercenter":[
    {
      "orig": "Liegen-ge-Bliebenes23",
      "url": "http://noravest.ch/img/Liegen-ge-Bliebenes23.jpg",
      "tn": "http://noravest.ch/img/Liegen-ge-Bliebenes23tn.jpg",
      "width": "700",
      "height": "525",
    },
    {
      "orig": "Liegen-ge-Bliebenes33",
      "url": "http://noravest.ch/img/Liegen-ge-Bliebenes33.jpg",
      "tn": "http://noravest.ch/img/Liegen-ge-Bliebenes33tn.jpg",
      "width": "700",
      "height": "525",
    }],
    "centerright": [
    {
      "orig": "Liegen-ge-Bliebenes26",
      "url": "http://noravest.ch/img/Liegen-ge-Bliebenes26.jpg",
      "tn": "http://noravest.ch/img/Liegen-ge-Bliebenes26tn.jpg",
      "width": "700",
      "height": "525",
    },
    {
      "orig": "Liegen-ge-Bliebenes24",
      "url": "http://noravest.ch/img/Liegen-ge-Bliebenes24.jpg",
      "tn": "http://noravest.ch/img/Liegen-ge-Bliebenes24tn.jpg",
      "width": "700",
      "height": "525",
    }
  ],
  "right": [
    {
      "orig": "Dinge51",
      "url": "http://noravest.ch/img/Dinge51.jpg",
      "tn": "http://noravest.ch/img/Dinge51tn.jpg",
      "width": "386",
      "height": "580",
    },
    {
      "orig": "Dinge52",
      "url": "http://noravest.ch/img/Dinge52.jpg",
      "tn": "http://noravest.ch/img/Dinge52tn.jpg",
      "width": "386",
      "height": "580",
    },
    {
      "orig": "Dinge53",
      "url": "http://noravest.ch/img/Dinge53.jpg",
      "tn": "http://noravest.ch/img/Dinge53tn.jpg",
      "width": "386",
      "height": "580",
    },
    {
      "orig": "Dinge54",
      "url": "http://noravest.ch/img/Dinge54.jpg",
      "tn": "http://noravest.ch/img/Dinge54tn.jpg",
      "width": "386",
      "height": "580",
    },
    {
      "orig": "Dinge55",
      "url": "http://noravest.ch/img/Dinge55.jpg",
      "tn": "http://noravest.ch/img/Dinge55tn.jpg",
      "width": "386",
      "height": "580",
    }
  ]
};